import { apiFetch } from './apiClient';

export interface ExportJob {
  id: number;
  type: 'product-report' | 'tabular-form';
  params: string;
  r2_key: string | null;
  status: 'pending' | 'processing' | 'done' | 'error';
  error: string | null;
  expires_at: string | null;
  row_count: number | null;
  created_by: number;
  created_at: string;
  completed_at: string | null;
}

export const exportService = (token: string | null) => ({
  history: (limit = 20) =>
    apiFetch<{ jobs: ExportJob[] }>(token, `/api/exports/history?limit=${limit}`),
  get: (jobId: number) =>
    apiFetch<{ job: ExportJob }>(token, `/api/exports/${jobId}`),
  downloadUrl: (jobId: number) =>
    apiFetch<{ url: string }>(token, `/api/exports/${jobId}/download`),
  productReport: (body: Record<string, unknown>) =>
    apiFetch<{ jobId: number; status: string }>(token, '/api/exports/product-report', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  tabularForm: (body: Record<string, unknown>) =>
    apiFetch<{ jobId: number; status: string }>(token, '/api/exports/tabular-form', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  remove: (id: number) =>
    apiFetch(token, `/api/exports/${id}`, { method: 'DELETE' }),
});
